import { type PortalRole } from '@shared/services/role-context.service';

import { type ShellNavItemConfig } from './shell-nav.types';

const userNavConfig: ShellNavItemConfig[] = [
  {
    id: 'user-dashboard',
    labelKey: 'NavBarLabelDashboard',
    icon: 'pi pi-th-large',
    routerLink: ['/user/dashboard'],
  },
];

const adminNavConfig: ShellNavItemConfig[] = [
  {
    id: 'admin-dashboard',
    labelKey: 'NavBarLabelDashboard',
    icon: 'pi pi-th-large',
    routerLink: ['/admin/dashboard'],
  },
  {
    id: 'admin-department',
    labelFactory: (context) => context.departmentNamePlural,
    icon: 'pi pi-building',
    routerLink: ['/admin/department'],
  },
  {
    id: 'admin-costs',
    labelKey: 'NavBarLabelCostDashboard',
    icon: 'pi pi-money-bill',
    routerLink: ['/admin/costs'],
    autoOpenOnRoutes: ['/admin/costs'],
  },
  {
    id: 'admin-cost-control-settings',
    labelKey: 'AdminSettingsCostControlTabTitle',
    icon: 'pi pi-wallet',
    routerLink: ['/admin/cost-control'],
  },
  {
    id: 'admin-cost-api-settings',
    labelKey: 'AdminSettingsCostApiTabTitle',
    icon: 'pi pi-cloud',
    routerLink: ['/admin/cost-api'],
  },
  {
    id: 'admin-settings',
    groupId: 'settings',
    labelKey: 'AdminSettingsNavSideBarTitle',
    icon: 'pi pi-cog',
    items: [
      {
        id: 'admin-settings-admins',
        labelKey: 'AdminSettingsAdminsTabTitle',
        icon: 'pi pi-users',
        routerLink: ['/admin/settings/admins'],
        autoOpenOnRoutes: ['/admin/invite/admin'],
      },
      {
        id: 'admin-settings-config',
        labelKey: 'AdminSettingsConfigTabTitle',
        icon: 'pi pi-cog',
        routerLink: ['/admin/settings/config'],
      },
      {
        id: 'admin-settings-master-keys',
        labelKey: 'AdminSettingsMasterKeysTabTitle',
        icon: 'pi pi-key',
        routerLink: ['/admin/settings/master-keys'],
      },
      {
        id: 'admin-settings-logs',
        labelKey: 'AdminSettingsLogsTitle',
        icon: 'pi pi-book',
        routerLink: ['/admin/settings/logs'],
      },
      {
        id: 'admin-settings-about',
        labelKey: 'AdminSettingsAboutTitle',
        icon: 'pi pi-sliders-h',
        routerLink: ['/admin/settings/about'],
      },
    ],
  },
];

const instanceAdminNavConfig: ShellNavItemConfig[] = [
  {
    id: 'instanceadmin-organizations',
    labelKey: 'ShellNavLabelOrganizations',
    icon: 'pi pi-building',
    routerLink: ['/in/dashboard'],
  },
  {
    id: 'instanceadmin-platform',
    labelKey: 'ShellNavLabelPlatform',
    icon: 'pi pi-cloud',
    routerLink: ['/in/platform'],
  },
];

const configByRole: Record<PortalRole, ShellNavItemConfig[]> = {
  user: userNavConfig,
  admin: adminNavConfig,
  instanceadmin: instanceAdminNavConfig,
};

export const getShellNavConfigForRole = (role: PortalRole): ShellNavItemConfig[] => {
  return configByRole[role];
};
